import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'admin/categorias',
		component: Base,
		children: [
			{
				path: '',
				name: 'CategoriasList',
				component: List,
				meta: {
					path: '/admin/categorias',
					pai: 'Admin',
					title: 'Admin - Categorias',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Categorias',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'CategoriasNovo',
				component: Form,
				meta: {
					path: '/admin/categorias',
					pai: 'Admin',
					title: 'Admin - Categorias - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Categorias',
						class: '',
						active: false,
						url: '/admin/categorias'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'CategoriasEditar',
				component: Form,
				meta: {
					path: '/admin/categorias',
					pai: 'Admin',
					title: 'Admin - Categorias - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Categorias',
						class: '',
						active: false,
						url: '/admin/categorias'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]